module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_5012.ff8d65d6.png";